import classNames from 'classnames';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { Portal } from 'src/components/Portal/Portal';
import { CookiesBanner } from 'src/components/CookiesBanner';
import { excludedPages } from '../helpers';
import { useSettings } from 'src/modules/settings';
import { useCheckGamePopUpAvailable } from '../utils';
import { PopUpCatchGame } from './PopUpCatchGame';

export const PopUpPortal = () => {
  const { pathname } = useLocation();

  const { isCookiesAccepted } = useSettings();
  const isShowPopUp = useCheckGamePopUpAvailable();

  const stickToBottom = useMemo(() => {
    return excludedPages.some((route) => pathname.includes(route)) || isCookiesAccepted;
  }, [isCookiesAccepted, pathname]);

  return (
    <Portal targetElementId="root">
      <div
        className={classNames(
          'fixed left-0 z-[500] w-full flex flex-col pointer-events-none',
          stickToBottom
            ? '768:bottom-0 bottom-20'
            : '768:bottom-[60px] bottom-[170px] 412:bottom-[150px] 568:bottom-[130px]'
        )}>
        {isShowPopUp && <PopUpCatchGame />}

        <CookiesBanner />
      </div>
    </Portal>
  );
};
